import {pollAsync} from '@yourcoach/async-utils';

interface CustomWindow extends Window {
  grecaptcha:
    | undefined
    | {
        enterprise: any;
      };
}

declare const window: CustomWindow;

const SCRIPT_ID = 'recaptcha';

let currentKey = '';

/**
 * @public
 */
export async function destruct(): Promise<boolean> {
  const script = document.querySelector(`#${SCRIPT_ID}`);

  if (script) {
    script.remove();
  }

  window.grecaptcha = undefined;

  return true;
}

export function execute(action: string): Promise<string> {
  if (!window.grecaptcha) {
    return Promise.reject(new Error('Seems you forgot to init Captcha!'));
  }

  return new Promise((resolve, reject) => {
    window.grecaptcha!.enterprise.ready(() => {
      window
        .grecaptcha!.enterprise.execute(currentKey, {action})
        .then(resolve)
        .catch(reject);
    });
  });
}

export async function init(key: string): Promise<boolean> {
  if (key !== currentKey) {
    await destruct();
  }

  if (document.querySelector(`#${SCRIPT_ID}`)) {
    await pollAsync(() => Boolean(window.grecaptcha), {
      timeout: 30 * 1000,
      timeoutMessage: "Couldn't initialize Captcha!",
    });

    return true;
  }

  currentKey = key;

  const js = document.createElement('script');

  js.id = SCRIPT_ID;

  js.src = `https://www.google.com/recaptcha/enterprise.js?render=${key}`;

  js.defer = true;

  document.getElementsByTagName('head')[0]?.append(js);

  await pollAsync(() => Boolean(window.grecaptcha), {
    timeout: 30 * 1000,
    timeoutMessage: "Couldn't initialize Captcha!",
  });

  return true;
}
